<template>
  <BaseDialog
    :is-open="isOpen"
    type="basic"
    :title="$t('member.kompetenzprofil.filterTitle')"
    @close="emits('close')"
  >
    <div class="flex flex-col gap-0.5">
      <LessonFilterItem
        v-for="lesson in lessons"
        :key="lesson.lessonId"
        class="first:rounded-t-large last:rounded-b-large"
        :lesson="lesson"
        :teachers="teachers"
        :selected="isSelected(lesson.lessonId)"
        @click="toggleLesson(lesson.lessonId)"
      />
    </div>
    <template #confirm>
      <BaseTextButton @click="apply">
        {{ $t('member.kompetenzprofil.apply') }}
      </BaseTextButton>
    </template>
    <template #dismiss>
      <BaseTextButton color="text" @click="emits('close')">
        {{ $t('common.cancel') }}
      </BaseTextButton>
    </template>
  </BaseDialog>
</template>

<script lang="ts" setup>
  import { ref, watch } from 'vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import type { KompetenzprofilLesson, MemberViewModel } from '../models/kompetenzprofil'
  import LessonFilterItem from './LessonFilterItem.vue'

  const props = defineProps<{
    isOpen: boolean
    lessons: ReadonlyArray<KompetenzprofilLesson>
    teachers: ReadonlyArray<MemberViewModel>
    modelValue: ReadonlyArray<string>
  }>()

  const emits = defineEmits<{
    close: []
    'update:modelValue': [lessonIds: string[]]
  }>()

  const draftLessonIds = ref<string[]>([])

  watch(
    () => props.isOpen,
    (open) => {
      if (open) {
        draftLessonIds.value = [...props.modelValue]
      }
    },
  )

  const isSelected = (lessonId: string) => draftLessonIds.value.includes(lessonId)

  const toggleLesson = (lessonId: string) => {
    if (isSelected(lessonId)) {
      draftLessonIds.value = draftLessonIds.value.filter((id) => id !== lessonId)
      return
    }
    draftLessonIds.value = [...draftLessonIds.value, lessonId]
  }

  const apply = () => {
    emits('update:modelValue', [...draftLessonIds.value])
  }
</script>
